import Vue from 'vue'

export default Vue.extend({
  name: 'Bookmark',

  props: {
    value: {
      type: Boolean as Prop<boolean>,
      default: false
    }
  },

  data () {
    return {
      selected: ''
    }
  },

  computed: {
    icon (): string {
      if (this.value) {
        return 'star'
      }
      return 'star_border'
    }
  },

  methods: {
    handleClickBookmark () {
      this.$emit('input', !this.value)
      this.$emit('click', !this.value)
      this.$emit('change', !this.value)
    }
  }
})
